import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7973d1d7: FaireBrandEntity = {
  token: "b_7973d1d7",
  type: "brand",
  name: "Talking Tables USA - Home, Party, Games and Seasonal Decor",
  avatarUrl:
    "https://cdn.faire.com/fastly/90477d744eb56284f49592e8e0aebb8b2120dd105cd2d26ce0c0d93840c25d2e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d3b3e9f95fe4a72485234a61340929b3e5042e4eaca1f2e8e25ae82e7527fc44.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/90477d744eb56284f49592e8e0aebb8b2120dd105cd2d26ce0c0d93840c25d2e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d3b3e9f95fe4a72485234a61340929b3e5042e4eaca1f2e8e25ae82e7527fc44.jpeg",
  location: "New York , NY, USA",
  minimumOrderDollars: 99,
  rating: 4.8,
  reviewCount: 288,
  isTopShop: true,
  isInsider: true,
  description:
    "The desire to bring people together and create memories lies at the heart of everything we do at Talking Tables. Knowing someone has purchased our colorful napkins or laugh-until-your-cheeks-ache games will never get old. With birthday candles, party supplies, games, home accessories and everything in between; our products are designed to get the table talking whatever the occasion. However, it’s not just about producing great party pieces for us (although it is a lot of fun). We’re constantly thinking about how we can offer more sustainable choices. From removing plastic packaging to introducing the first recyclable paper cups, you don't have to comprise on design or style to be planet friendly. We’re equally proud to be a certified B Corporation - so you know we deliver on our promises – and hold a King’s Award for Enterprise for International Trade.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:47.056Z",
    importedBy: "entity-db-cli",
  },
};
